import React from "react"
import { flexRender } from "@tanstack/react-table"
import { FilterOverlay } from "./Filter"
import { ColumnMenu } from "./ColumnMenu/ColumnMenu"
import { useDrag, useDrop } from "react-dnd"


export const reorderColumn = (draggedColumnId, targetColumnId, columnOrder) => {
  columnOrder.splice(
    columnOrder.indexOf(targetColumnId),
    0,
    columnOrder.splice(columnOrder.indexOf(draggedColumnId), 1)[0]
  )
  return [...columnOrder]
}

export const DnDColumnHeader = ({
  header,
  table,
  allowResizeCols,
  allowColumnFilter,
  allowReorderCols,
  allowColumnPinning,
  allowColumnSorting,
  allowColumnGrouping,
  allowColumnSortingSingle
}) => {
  const { getState, setColumnOrder } = table
  const { columnOrder } = getState()
  const { column } = header
  const [, dropRef] = useDrop({
    accept: "column",
    drop: draggedColumn => {
      const newColumnOrder = reorderColumn(
        draggedColumn.id,
        column.id,
        columnOrder
      )
      setColumnOrder(newColumnOrder)
    }
  })
  const [{ isDragging }, dragRef, previewRef] = useDrag({
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    item: () => column,
    type: "column"
  })

  return (
    <th
      ref={dropRef}
      className="position-relative tabletankstackthtd"
      key={header.id}
      style={{
        width: header.getSize(),
        color: '#595d6e',
        ...(header.column.getIsGrouped()
          ? {
              backgroundColor: "#d7e5fc"
            }
          : {}),
        opacity: isDragging ? 0.5 : 1,
        fontSize:'13px',
        fontWeight: 500
      }}
      colSpan={header.colSpan}
    >
      <div ref={previewRef}>
        {header.isPlaceholder ? null : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              {allowColumnSortingSingle && header.column.getCanSort() ? 
                <div
                  onClick={header.column.getToggleSortingHandler()}
                  style={{ cursor: 'pointer' }}
                >
                  {flexRender(header.column.columnDef.header, header.getContext())}
                  {{
                    asc: "▲",
                    desc: "▼"
                  }[header.column.getIsSorted()] ?? ""}
                  
                </div>
                :
                <>
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </>
              }
           
              <div className="d-flex align-self-center" style={{ marginLeft: '15px' }}>
                {(allowReorderCols || allowColumnGrouping) &&
                  !header.column.columns.length && (
                    <div
                      ref={dragRef}
                      className="text-secondary px-1 align-self-center"
                    >
                      <i className="fas fa-up-down-left-right" />
                    </div>
                  )}
                {allowColumnFilter && header.column.getCanFilter() ? (
                  <FilterOverlay column={header.column} table={table} />
                ) : null}
                { 
                  !allowColumnSortingSingle &&
                  <>
                    <ColumnMenu
                      header={header}
                      allowColumnGrouping={allowColumnGrouping}
                      allowColumnPinning={allowColumnPinning}
                      allowColumnSorting={allowColumnSorting}
                      allowColumnSortingSingle={allowColumnSortingSingle}
                    />
                  </>
                }
                
              </div>
            </div>
            {allowResizeCols && (
              <div
                className="position-absolute h-100 bg-secondary"
                style={{
                  right: 0,
                  top: 0,
                  cursor: "col-resize",
                  width: "2px"
                }}
                onMouseDown={header.getResizeHandler()}
                onTouchStart={header.getResizeHandler()}
              />
            )}
          </>
        )}
      </div>
    </th>
  )
}
